import React from "react"
import PropTypes from "prop-types"
import Icon from "components/common/Icon"
import CircleImage from "components/common/CircleImage"
import { Icon as FeatherIcon } from "ui/Icon"
import styles from "./GuideRatingInfo.module.css"

const RATING_STARS = 5

const GuideRatingInfo = ({ guide }) => {
  if (!guide) return null

  const name = guide.company_name || guide.display_name

  return (
    <div className="text-end flex-shrink-0">
      <div
        className={`d-inline-flex align-items-center gap-1 text-dark fw-semibold fs-7 rounded-pill py-1 px-2 mb-2 ${styles.topRatedBadge}`}
      >
        <FeatherIcon type="feather" name="Award" color="#212529" width={16} height={16} />
        <span>Top Rated</span>
      </div>
      <div className="hstack gap-2 align-items-center">
        <CircleImage
          src={guide.logo}
          alt={name || "Guide"}
          size={40}
          placeholderIconName="MyProfile"
          className="flex-shrink-0"
          border={false}
        />
        <span className="fs-7 fw-semibold text-dark lh-sm">{name}</span>
        <div className="hstack gap-1">
          {new Array(RATING_STARS).fill(null).map((_, index) => (
            <Icon key={index} iconName="StarNew" className="text-primary-second" size={16} block />
          ))}
        </div>
      </div>
    </div>
  )
}

GuideRatingInfo.propTypes = {
  guide: PropTypes.shape({
    company_name: PropTypes.string,
    display_name: PropTypes.string,
    logo: PropTypes.string,
    top_rated: PropTypes.bool
  })
}

export default GuideRatingInfo
